import React from "react";
import Link from "gatsby-link";
import "swiper/dist/css/swiper.min.css";
import "../../pages/index.styl";
import Help from "./Help";
import LoadingOverlay from "react-loading-overlay";
import 'isomorphic-fetch'

class ForgotPassword extends React.Component {
  state = {
    username: "",
    email: "",
    rememberme: "",
    action: "",
    errorMessage: "",
    message: "",
    success: false,
    redirect: "",
    submited: false,
    isActive: false,
    help: ""
  };

  updateUsername = event => {
    this.setState({ username: event.target.value });
  };

  updateEmail = event => {
    this.setState({ email: event.target.value });
  };

  postData = url => {
    // Default options are marked with *
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
        //"Content-Type": "text/html",
        //"Accept" : "text/html"//,
        //  "Accept-Encoding": "gzip, deflate"
      },
      body:
        "username=" +
        this.state.username +
        "&email=" +
        this.state.email +
        "&portal=true"
    }).then(response => response.json()); // parses response to JSON
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isActive: true });
    this.postData("/wbe/CommandServlet?command=resetPassword")
      .then(data => {
        //console.log(JSON.stringify(data))
        this.setState({
          errorMessage: data.data.errorMessage,
          message: data.data.message,
          success: data.data.success,
          redirect: data.data.redirect,
          submited: true
        });
      });
    this.setState({ isActive: false });
  };

  displayMessage = () => {
    if (this.state.success) {
      document.getElementById("password-reset-form").reset();
      return (
        <div className="header-form__head">
          <div className="header-form__text">
            A temporary password has been sent to your email. Once you have
            received it, please click <Link to="/login">here</Link> to log in.
          </div>
        </div>
      );
    } else {
      if (this.state.submited) {
        return (
          <div className="header-form__head">
            <div className="header-form__text">
              <span className="alert-message">
                Username/e-mail does not match our records. Please try again.
              </span>
            </div>
          </div>
        );
      } else {
        return (
          <div className="header-form__head">
            <div className="header-form__text">
              {" "}
              A temporary password will be sent to your e-mail which you can then
              use to reset your password.
            </div>
          </div>
        );
      }
    }
  };


  displayHelp = () => {
    if (this.state.help === "show") {
      return (<Help id="help"></Help>);
    };
  };

  toggleHelp = () => {
    if(this.state.help === "show") {
      this.setState({ help: "hide"});
    } else {
      this.setState({ help: "show"});
    }
  }

  render() {
    return (
      <div>
        <LoadingOverlay active={this.state.isActive} spinner text="Loading...">
          <form
            id="password-reset-form"
            name="forgot"
            action={this.state.action}
            onSubmit={event => {
              this.handleSubmit(event);
            }}
            method="post"
            className="header-form"
            style={{ marginTop: 50, flexWrap: "wrap", textAlign: "center"  }}
          >
            <span className="alert-message">{this.state.errorMessage}</span>
            {this.displayMessage()}
            <div className="header-form__inner">
            <input
              id="email"
              name="email"
              type="email"
              placeholder="Email..."
              className="c-input header-form__input"
              tabIndex="1"
              style={{ order: 1 }}
              required
              onChange={event => {
                this.updateEmail(event);
              }}
            />
              <div className="header-form__options header-form__options--1">
                <a href="#0" className="header-form__label" onClick={() => {this.toggleHelp();}}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 15 15"
                    width={15}
                    height={15}
                    fill="#E21E32"
                    style={{ marginRight: 6 }}
                  >
                    <path
                      d="M727.8 1042.6l-.7.4-.8.9.3.2.5-.5.1.1-.1.7-1.1 3.1-.2 1c0 .4.3.6.7.5l.7-.4.6-.7-.3-.3-.4.4-.1-.1.2-.7 1.1-3.1.2-1c-.1-.4-.3-.6-.7-.5zm1.5-1.5c-.2.4-.7.6-1.1.4-.4-.2-.6-.7-.4-1.1.2-.4.6-.5.9-.4.5.2.7.7.6 1.1zm-1.8 9.9a6.5 6.5 0 1 0 0-13 6.5 6.5 0 1 0 0 13m0 1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z"
                      transform="translate(-720 -1037)"
                    />
                  </svg>
                  Help?
                </a>
              </div>
              <input
                id="username"
                name="username"
                placeholder="Username..."
                className="c-input header-form__input"
                tabIndex="2"
                style={{ order: 3 }}
                required
                onChange={event => {
                  this.updateUsername(event);
                }}
              />
              <div className="header-form__options header-form__options--2">
                <label className="header-form__label header-form__link">
                  Forgot your &nbsp;<Link to="/forgotUsername">username</Link>
                  &nbsp;?
                </label>
              </div>
              <button
                type="submit"
                className="c-btn c-btn--white header-form__btn"
                tabIndex="3"
              >
                Reset
                <svg
                  viewBox="0 0 30.595 12.238"
                  width="24"
                  height="11"
                  fill="currentColor"
                  style={{ marginLeft: 5 }}
                >
                  <g transform="translate(-5 -22)">
                    <path
                      d="M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z"
                      transform="translate(827 -1165.238)"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </form>
          {this.displayHelp()}
        </LoadingOverlay>
      </div>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/Auth/ForgotPassword.js